import React from 'react'

interface Props {
  width?: string | number
  height?: string | number
  fillColor?: string
  [x: string]: unknown // for the rest property
}

const EcoFriendly: React.FunctionComponent<Props> = ({
  width = '24',
  height = '22',
  fillColor = '#2D2926',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 24 22" {...rest}>
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M23.46 2.26c-2.91 0-7 .24-9.11 2.34-1.55 1.55-1.58 4.52-.64 6.37-.976 1.424-1.693 3.008-2.12 4.68-.288-2.102-.902-4.147-1.82-6.06 1.44-1.65 1.67-5.36-.12-7.15C7.55.34 3.45.1.54.1.24.106 0 .35 0 .65c0 2.9.24 7 2.34 9.1.985.873 2.275 1.322 3.59 1.25 1.045.018 2.077-.23 3-.72 1.11 2.31 2 5.77 2 11 0 .3.24.545.54.55.304 0 .55-.246.55-.55-.112-3.303.717-6.57 2.39-9.42 1.033.86 2.347 1.31 3.69 1.26 1.317.055 2.604-.404 3.59-1.28C23.76 9.81 24 5.71 24 2.8c0-.298-.242-.54-.54-.54zM3.11 9c-1.69-1.69-2-5.13-2-7.78 2.66 0 6.1.32 7.79 2 1.22 1.23 1.18 4 .32 5.34-.884-1.473-2.095-2.722-3.54-3.65-.138-.086-.268-.183-.39-.29-.138-.137-.338-.191-.526-.14-.188.05-.335.196-.385.384-.05.188.003.389.141.526.17.152.35.293.54.42 1.378.891 2.52 2.102 3.33 3.53-1.39.83-4.07.85-5.28-.34zm12.01 2.16c1.17 1.16 4.4 1.36 5.77 0v-.02c1.69-1.7 1.99-5.14 2.02-7.77-2.66 0-6.1.31-7.79 2-1.04 1.04-1.16 3.16-.65 4.63 1.166-1.377 2.615-2.486 4.25-3.25.28-.13.613-.026.77.24.073.122.09.269.048.404-.042.135-.14.247-.268.306h-.08c-1.636.757-3.07 1.887-4.19 3.3l.12.16z"
      clipRule="evenodd"
    />
  </svg>
)

export default EcoFriendly
